import { useOrderStatusHasEarnedLoyaltyPointsQuery } from '../../graphql/OrderStatus.generated';

/**
 * Returns a boolean value for whether the customer has earned loyalty points for this order.
 */
export const useHasEarnedLoyaltyPoints = (
  isLoggedIn: boolean,
  orderId?: string,
  isOrderCancelled?: boolean,
) => {
  const variables = { id: orderId ?? '' };
  const pause = !isLoggedIn || !orderId || isOrderCancelled;

  const [{ data }] = useOrderStatusHasEarnedLoyaltyPointsQuery({
    pause,
    variables,
  });

  if (data?.orderStatus?.__typename === 'OrderStatus') {
    return data.orderStatus.order.hasEarnedLoyaltyPoints;
  }

  return false;
};
